(ns iris.styles.chip
  (:require 
   [shadow.css :refer [css]]))

;; (defn chip []
;;   {:display "inline-block"
;;    :border-radius "34px"
;;    :background "#fff"
;;    :padding "3px"
;;    :border "1px solid #ccc"
;;    :margin "0 4px 4px 0"
;;   ;;  :margin "0 0 4px 0"
;;    :cursor "pointer"})

;; (defn label []
;;   {:margin "0 5px"})

;; (defn remove-btn []
;;   {:font-size "12px"
;;    :padding "0 3px"
;;    :color "#333"})


(def $chip
  (css {:display "inline-block"
        :border-radius "34px"
        :background "#fff"
        :padding "3px"
        :border "1px solid #ccc"
        :margin "0 4px 4px 0"
        ;;  :margin "0 0 4px 0"
        :cursor "pointer"}))

(def $label
  (css {:margin "0 5px"}))

(def $remove-btn
  (css {:font-size "12px"
        :padding "0 3px"
        :color "#333"}))

